import { Component, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';

import { Entity, EntityInterface } from '@proman/services/entity.service';
import { UploaderService } from '@proman/services/uploader.service';

import { getCurrUser } from '@proman/store/curr-user';
import { PromanFile } from '@proman/interfaces/entity-interfaces';
import { ImagePathService } from '@proman/services/image-path.service';

declare interface BugTrackerMessage {
    person: number;
    screenshot: number;
    url: string;
    comment: string;
}

@Component({
    selector: 'pm-bug-tracker-dialog',
    template: `
        <form #createForm="ngForm"
              [formGroup]="form"
              (ngSubmit)="confirm()">
            <pro-dialog-title title="system_bug_message"></pro-dialog-title>
            <div mat-dialog-content>
                <img [src]="getImage()"
                     style="max-width: 600px;">
                <p>
                    <b>{{ 'location' | translate }}</b> {{ message.url }}
                </p>
                <br>
                <pm-txt [config]="{ label: 'comments', type: 'textarea' }"
                        [value]="message.comment"
                        (onChange)="set('comment', $event)"></pm-txt>
            </div>
            <pro-dialog-actions [isCallbackDisabled]="!screenshotFile" variant="create"></pro-dialog-actions>
        </form>
    `
})

export class BugTrackerDialogComponent {
    form: UntypedFormGroup = new UntypedFormGroup({});
    bugTrackerEntity: EntityInterface;
    message: BugTrackerMessage;
    screenshotFile: PromanFile;

    constructor(
        @Inject(MAT_LEGACY_DIALOG_DATA) private data: any,
        private Entity: Entity,
        private Uploader: UploaderService,
        private ImagePath: ImagePathService,
        private store: Store,
        private dialogRef: MatLegacyDialogRef<BugTrackerDialogComponent>
    ) {
        this.bugTrackerEntity = this.Entity.get('bug_tracker');
        this.store.select(getCurrUser).pipe(filter(value => !!value))
            .subscribe((currUser) => {
                this.message = {
                    person: currUser.person.id,
                    screenshot: null,
                    url: this.data.url,
                    comment: ''
                };

                if (this.data.screenshot) {
                    fetch(this.data.screenshot).then((response) => response.blob()).then(async (blob) => {
                        const fileInstance = new File([blob], `screenshot_${new Date().toString()}.png`, { type: 'image/png' });
                        this.Uploader.init(() => ({}), {}).upload([fileInstance], { multiple: false }).then((result: PromanFile[]) => {
                            console.log(result);
                            this.screenshotFile = result[0];
                        });
                    });
                }
            });
    }

    set(property: string, value: unknown) {
        this.message[property] = value;
    };

    getImage = () => this.ImagePath.getFile(this.screenshotFile, 'png');

    confirm() {
        this.message['screenshot'] = this.screenshotFile.id;
        this.bugTrackerEntity
            .postRequest('post', this.message)
            .then(() => {
                console.log(this.ImagePath.getFile(this.screenshotFile, 'png'));
                this.dialogRef.close(1);
            });
    };
}
